import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTag,
  fetchTagById,
  updateStatusInTag,
  updateTag,
  fetchAllDropdowns,
  exportOTeamsCSV,
  fetchColumnFilterDropdown,
} from "./thunk";

interface TagState {
  tagList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  orgDropDown: any[];
  departmentDropDown: any[];
  orgCityDropDown: any[];
  teamsDropDown: any[];
  values: any[];
  dropdownOptions: Record<string, any[]>;
}

const initialState: TagState = {
  tagList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  exportCSVLoading: false,
  exportCSVError: null,
  dropdownOptions: {},
  orgDropDown: [],
  departmentDropDown: [],
  orgCityDropDown: [],
  teamsDropDown: [],
  values: [],
};

const tagSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    // ✅ Local update reducer
   updateTagLocal: (state, action) => {
  const { id, tag_name } = action.payload;
  state.tagList = state.tagList.map((tag: any) =>
    tag.tag_id === id ? { ...tag, tag_name } : tag
  );
},

  },
  extraReducers: (builder) => {
    builder
      // Fetch All Tags
      .addCase(fetchTag.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTag.fulfilled, (state, action) => {
        state.loading = false;
        state.tagList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch tags";
      })

      // Fetch Single Tag by ID
      .addCase(fetchTagById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchTagById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Tag via API
      .addCase(updateTag.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.tagList = state.tagList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update tag";
      })

      // Update Status
      .addCase(updateStatusInTag.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.tagList = state.tagList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update tag status";
      })

      // Export CSV
      .addCase(exportOTeamsCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportOTeamsCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportOTeamsCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      })

      // Column Filter Dropdown
      .addCase(fetchColumnFilterDropdown.fulfilled, (state, action) => {
        const { column, data } = action.payload;
        state.dropdownOptions[column] = data || [];
      })
      .addCase(fetchColumnFilterDropdown.rejected, (state, action) => {
        const column = action.meta.arg;
        state.dropdownOptions[column] = [];
        console.error(`Failed to fetch dropdown for column ${column}`);
      });
  },
});

export const { updateTagLocal } = tagSlice.actions;
export default tagSlice.reducer;
